import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CheckboxModule } from 'primeng/checkbox';
// PrimeNG imports.
import { TableModule } from 'primeng/table';
import { PaginatorModule } from 'primeng/paginator';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { FileUploadModule } from 'primeng/fileupload';
import { DropdownModule } from 'primeng/dropdown';

// App routing and components.
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PublicLayoutComponent } from './components/public-layout/public-layout.component';
import { PublicHomeComponent } from './components/public-home/public-home.component';
import { CourseListComponent } from './components/course-list/course-list.component';
import { CourseDetailComponent } from './components/course-detail/course-detail.component';
import { CartComponent } from './components/cart/cart.component';
import { OccurrencePickerComponent } from './components/occurrence-picker/occurrence-picker.component';
import { CustomerLoginComponent } from './components/customer-login/customer-login.component';
import { CustomerRegisterComponent } from './components/customer-register/customer-register.component';
import { CustomerLayoutComponent } from './components/customer-layout/customer-layout.component';
import { CustomerDashboardComponent } from './components/customer-dashboard/customer-dashboard.component';
import { CustomerProfileComponent } from './components/customer-profile/customer-profile.component';
import { CustomerPurchasesComponent } from './components/customer-purchases/customer-purchases.component';
import { AdminLoginComponent } from './components/admin-login/admin-login.component';
import { AdminLayoutComponent } from './components/admin-layout/admin-layout.component';
import { AdminDashboardComponent } from './components/admin-dashboard/admin-dashboard.component';
import { AdminCoursesComponent } from './components/admin-courses/admin-courses.component';
import { AdminTagsComponent } from './components/admin-tags/admin-tags.component';
import { AdminUsersComponent } from './components/admin-users/admin-users.component';
import { AdminCustomersComponent } from './components/admin-customers/admin-customers.component';
import { AdminOrdersComponent } from './components/admin-orders/admin-orders.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { BookingConfirmationComponent } from './components/booking-confirmation/booking-confirmation.component';
import { AboutUsComponent } from './components/about-us/about-us.component';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { ConfirmModalComponent } from './modals/confirm-modal/confirm-modal.component';
import { EditorModule } from 'primeng/editor';
import { TrainingComponent } from './components/training/training.component';
import { NewCourseListComponent } from './components/new-course-list/new-course-list.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { StripePaymentComponent } from './components/stripe-payment/stripe-payment.component';
import { VocCourseComponent } from './components/voc-course/voc-course.component';
import { AdminVOCComponent } from './components/admin-voc/admin-voc.component';
import { VOCPaymentComponent } from './components/vocpayment/vocpayment.component';

import { AdminShortCourseOrdersComponent } from './components/admin-short-course-orders/admin-short-course-orders.component';
import { TooltipModule } from 'primeng/tooltip';
import { AdminVocCourseDetailComponent } from './components/admin-voc-course-detail/admin-voc-course-detail.component';
import { QuillModule } from 'ngx-quill';
import { XCoursesListComponent } from './components/x-courses-list/x-courses-list.component';
import { XCourseCalendarComponent } from './components/x-course-calendar/x-course-calendar.component';
import { AdminXEnquiriesComponentComponent } from './components/admin-xenquiries-component/admin-xenquiries-component.component';
import { VocCompanyFormComponent } from './components/voc-company-form/voc-company-form.component';
import { XPaidRegistrationComponent } from './components/x-paid-registration/x-paid-registration.component';
import { ChooseEsignatureComponent } from './components/tools/choose-esignature/choose-esignature.component';
import { SignaturePadComponent } from './components/tools/signature-pad/signature-pad.component';
import { XCourseMultiFormComponent } from './components/x-course-multi-form/x-course-multi-form.component';
import { EmailValidatorDirective } from './services/email-validator.directive';
import { GtoComponent } from './components/gto/gto.component';
import { BreakingTheCycleComponent } from './components/breaking-the-cycle/breaking-the-cycle.component';
import { HsrTrainingComponent } from './components/hsr-training/hsr-training.component';
import { XShortCourseListComponent } from './components/x-short-course-list/x-short-course-list.component';
import { XShortCourseDetailsComponent } from './components/x-short-course-details/x-short-course-details.component';
import { XSingleEnquireComponent } from './components/x-single-enquire/x-single-enquire.component';
import { AdminShortCoursesComponent } from './components/admin-short-courses/admin-short-courses.component';
import { CorporateComponent } from './components/corporate/corporate.component';
import { AdminXbookingsComponent } from './components/admin-xbookings/admin-xbookings.component';
import { XParticipantRegistrationComponent } from './components/x-participant-registration/x-participant-registration.component';
import { PhoneNumberValidationDirective } from './services/phone.number.validation.directive';
import { XHsrCoursesComponent } from './components/x-hsr-courses/x-hsr-courses.component';
import { ManualSyncComponent } from './components/manual-sync/manual-sync.component';
import {  SafeHtmlPipe  } from './services/safehtml.val.directive';
import { SelectButtonModule } from 'primeng/selectbutton';
import { NormalizeRteSpacingPipe } from './services/normalizeRteSpaceingPipe';
import { XVocListComponent } from './components/x-voc-list/x-voc-list.component';
import { AdminPublicHomeContentComponent } from './components/admin-public-home-content/admin-public-home-content.component'; 
// Root app module.
@NgModule({
  declarations: [
    AppComponent,
    PublicLayoutComponent,
    PublicHomeComponent,
    CourseListComponent,
    CourseDetailComponent,
    CartComponent,
    OccurrencePickerComponent,
    CustomerLoginComponent,
    CustomerRegisterComponent,
    CustomerLayoutComponent,
    CustomerDashboardComponent,
    CustomerProfileComponent,
    CustomerPurchasesComponent,
    AdminLoginComponent,
    AdminLayoutComponent,
    AdminDashboardComponent,
    AdminCoursesComponent,
    AdminTagsComponent,
    AdminUsersComponent,
    AdminCustomersComponent,
    AdminOrdersComponent,
    NotFoundComponent,
    ConfirmModalComponent,
    BookingConfirmationComponent,
    AboutUsComponent,
    ContactUsComponent,
    TrainingComponent,
    NewCourseListComponent,
    StripePaymentComponent,
    VocCourseComponent,
    AdminVOCComponent,
    VOCPaymentComponent,
    AdminShortCourseOrdersComponent,
    AdminVocCourseDetailComponent,
    XCoursesListComponent,
    XCourseCalendarComponent,
    AdminXEnquiriesComponentComponent,
    VocCompanyFormComponent,
    XPaidRegistrationComponent,
    ChooseEsignatureComponent,
    SignaturePadComponent,
    XCourseMultiFormComponent,
    GtoComponent,
    BreakingTheCycleComponent,
    HsrTrainingComponent,
    XShortCourseListComponent,
    XShortCourseDetailsComponent,
    XSingleEnquireComponent,
    AdminShortCoursesComponent,
    CorporateComponent,
    AdminXbookingsComponent,
    XParticipantRegistrationComponent,
    XHsrCoursesComponent,
    ManualSyncComponent,
    XVocListComponent,
    AdminPublicHomeContentComponent,
  ],
  imports: [
    QuillModule.forRoot(),
    EmailValidatorDirective,
    PhoneNumberValidationDirective, 
    NormalizeRteSpacingPipe,
    SafeHtmlPipe ,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    TableModule,
    PaginatorModule,
    ButtonModule,
    TagModule,
    DialogModule,
    InputTextModule,
    InputTextareaModule,
    FileUploadModule,
    DropdownModule,
    EditorModule,
    FullCalendarModule,
    TooltipModule,
SelectButtonModule,
CheckboxModule,
RadioButtonModule   
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
